// core vue vendor
import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'
import store from './store/index'

// 3rd party vue vendors
import VeeValidate from 'vee-validate';
import VueMq from 'vue-mq'
import VueClipboard from 'vue-clipboard2';
import VueLogger from 'vuejs-logger';
import vClickOutside from 'v-click-outside'

// other third party vendors
import moment from 'moment-timezone';
import _ from 'lodash';

// app specific imports
import PORTAL from "./config/portals/config.js";

Vue.config.productionTip = false


const isProduction = process.env.NODE_ENV === 'production';

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};


Vue.use(vClickOutside)
Vue.use(VueLogger, options);


Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity,
  }
})


Vue.use(VueClipboard);

/*
*/

Vue.use(VeeValidate, { locale: "nb_NO", inject: false });


// axios.defaults.headers.common['version'] = "2018-06-27";


router.beforeEach((to, from, next) => {


    document.title = PORTAL.title;


    let canOrder = _.get(store.state.user.user, 'retailer.group.canOrder', true);

    if (!store.state.user.user.token.length && to.meta.requiresAuth) {
      // redirect to login if no token
      next('/');
    } else if (store.state.user.user.token.length && to.path === "/") {
      // redirect to login if no token
      canOrder ? next("/cars") : next('/orders');
    } else if (store.state.user.user.token.length && to.path === "/user/new") {
      next('/user');

    } else if (store.state.user.user.token.length && to.path === "/cars" && !canOrder) {
      next('/orders');

    } else {
      next()
    }
  }
);

Vue.config.productionTip = false;

moment.locale("nb_NO");


Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('D. MMM YYYY')
  }
});

Vue.filter('formatDateFullCompact', function (value) {
  if (value) {
    return moment(String(value)).format("D. MMM 'YY")
  }
});


Vue.filter('formatDateShort', function (value) {
  if (value) {
    return moment(String(value)).format('D. MMM')
  }
});


Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
});

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('nb-NO', {
    style: 'currency',
    currency: 'NOK',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});


Vue.filter('timeAgo', function (value) {
  if (value) {
    var now = moment(new Date()); //todays date
    var end = moment(String(value)); // another date
    return moment.duration(now.diff(end)).humanize();
  }
});

""
Vue.filter('phone', function (phone) {
  let val = phone.replace(/ /g, "");
  return this.value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
});


Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('camelize', function (value) {
  return _.capitalize(value);
});


new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
